/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { tokens } from "../../../theme";
import { Box, Typography, useTheme } from "@mui/material";
import { DataGridPro, GridActionsCellItem } from "@mui/x-data-grid-pro";

import { tabbedDataGridPage } from "../../../styles/commonPageStyles";
import { useListAllOsSoftware } from "../../../api/softwareImages";
import { useSubmitOsPatchRequestDialog } from "../Dialogs/SubmitOsPatchRequestDialog";
import { useNavigate } from "react-router-dom";

const Os = ({ engine, releaseBranch, displayNotification, reloadToggle }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const navigate = useNavigate();

  const [os, setOs] = useState([]);

  const { submitOsPatchRequestDialog, setOpenSubmitOsPatchRequestDialog } =
    useSubmitOsPatchRequestDialog(
      () => navigate(`/apps/tessell/software-images/os/builds`),
      displayNotification
    );

  const {
    postData: listAllOs,
    response: listAllOsResp,
    isLoading: isLoadingOs,
  } = useListAllOsSoftware(engine, releaseBranch);

  useEffect(() => {
    listAllOs();
  }, [engine, releaseBranch, reloadToggle]);

  useEffect(() => {
    if (Array.isArray(listAllOsResp?.os)) {
      setOs(listAllOsResp.os);
    } else {
      setOs([]);
    }
  }, [listAllOsResp]);

  const columns = [
    {
      field: "osVersionName",
      renderHeader: () => <Typography variant="h5">Version Name</Typography>,
      flex: 2,
      cellClassName: "name-column--cell",
      renderCell: ({ row: { osVersionName } }) => (
        <Typography variant="h5">{osVersionName || ""}</Typography>
      ),
    },
    {
      field: "osName",
      flex: 2,
      renderHeader: () => <Typography variant="h5">OS Name</Typography>,
      renderCell: ({ row: { osName } }) => (
        <Typography variant="h5">{osName ?? ""}</Typography>
      ),
    },
    {
      field: "osVersion",
      flex: 2,
      renderHeader: () => <Typography variant="h5">Version</Typography>,
      renderCell: ({ row: { osVersion } }) => (
        <Typography variant="h5">{osVersion ?? ""}</Typography>
      ),
    },

    {
      field: "actions",
      type: "actions",
      flex: 0.5,
      getActions: ({ row }) => [
        <GridActionsCellItem
          label="Submit Patch Request"
          onClick={() => {
            setOpenSubmitOsPatchRequestDialog(
              {
                engine: engine,
                releaseBranch: releaseBranch,
                osName: row?.osName,
                oldVersion: row?.osVersion,
                oldVersionName: row?.osVersionName,
                dbSoftware: row?.dbSoftware,
              },
              Object.keys(row?.clouds)
            );
          }}
          showInMenu
        />,
      ],
    },
  ];

  return (
    <Box sx={tabbedDataGridPage.dataGridBoxStyles(colors)}>
      {submitOsPatchRequestDialog}
      <DataGridPro
        disableSelectionOnClick
        getRowId={(row) => row?.osVersionName}
        loading={isLoadingOs}
        rows={os}
        columns={columns}
      />
    </Box>
  );
};

export default Os;
